import React, { useState,useEffect } from 'react'
import './AryaAgents.css';

import { DashboardRoutes } from './routes/DashboardRoutes';

const SplashScreen = () =>{
    return(
        <div className='d-flex justify-content-center align-items-center' style={{minHeight:'100vh'}}>
            <h1>Cargando...</h1>
        </div>
    )
}

export const AryaAgents = () => {
    let URL_DEV = ''
    if(window.location.hostname.toLowerCase() === 'localhost')
        URL_DEV = 'https://agentesv4.wsoft.com.mx/'

    const [splashScreen,setSplashScreen] = useState(true);
    const [initData,setInitData] = useState([]);

    const getInitData = () => {
        fetch(`${URL_DEV}REST/controllers/mainController?opt=initApp`,{
            method:'post',
            mode:'cors',
        })
        .then( response => response.json() )
        .then( data => {
            setSplashScreen(false);
            setInitData(data);

            if(!data.logged && window.location.pathname.indexOf('login') === -1) {
                localStorage.removeItem("userAryaAgents")
                window.location = '/login'
            } else {
                if(window.location.pathname.indexOf('login') !== -1)
                    window.location = '/home'
            }

        })
    }
    
    useEffect(()=>{
        getInitData();
    },[]);

    if(splashScreen) return <SplashScreen />

    return (
        <DashboardRoutes initData={initData} />
    )
}
